export default "__VITE_PUBLIC_ASSET__d25df527__"